import { useState, useEffect, useContext } from 'react';
import EnvironmentContext from '../contexts/EnvironmentContext';
import TListing from '../types/TListing';
import getListings from '../apiClient/getListings';
import { TSearchRequest } from '../types/TConfigurablePage';

type TParams = {
  searchRequest: TSearchRequest;
};

const useFetchListings = ({ searchRequest }: TParams) => {
  const { xsrfToken } = useContext(EnvironmentContext);

  const [listings, setListings] = useState<TListing[]>([]);
  const [totalCount, setTotalCount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);

  const {
    query,
    l1CategoryId,
    l2CategoryId,
    attributeIds,
    attributeRanges,
    attributeKeys,
    sorting: { sortBy, sortOrder } = {},
    limit,
    offset,
    sellerIds,
  } = searchRequest;

  useEffect(() => {
    setIsError(false);
    setIsEmpty(false);
    setIsLoading(true);

    (async () => {
      try {
        const data = await getListings({
          searchRequest: {
            query,
            l1CategoryId,
            l2CategoryId,
            attributeIds,
            attributeRanges,
            attributeKeys,
            sellerIds,
            sorting: {
              sortBy: sortBy || 'SORT_INDEX',
              sortOrder: sortOrder || 'DECREASING',
            },
            limit,
            offset,
          },
          xsrfToken,
        });

        setListings(data.listings);
        setTotalCount(data.totalResultCount);
        setIsLoading(false);
        setIsError(false);
        setIsEmpty(!data.listings?.length);
      } catch {
        setIsLoading(false);
        setIsError(true);
      }
    })();
  }, [
    query,
    l1CategoryId,
    l2CategoryId,
    attributeIds,
    sortOrder,
    sortBy,
    limit,
    offset,
    xsrfToken,
    attributeRanges,
    attributeKeys,
    sellerIds,
  ]);

  return { listings, totalCount, isLoading, isError, isEmpty };
};

export default useFetchListings;
